/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { z } from 'zod';

/** Money is paise (integer); 50 lakh cap mirrors the API DTO. */
const MAX_AMOUNT_PAISE = 5_000_000_00;

const grossPaise = z.coerce
  .number({ invalid_type_error: 'Enter an amount' })
  .int('Amount must be a whole number of paise')
  .min(1, 'Enter an amount')
  .max(MAX_AMOUNT_PAISE, 'Amount is too large');

/** Create a payroll run (Figma Finance → "New Payroll Run"). Mirrors `CreatePayrollRunDto`. */
export const CreatePayrollRunSchema = z.object({
  periodLabel: z.string().trim().min(1, 'Enter a period').max(60),
  periodStart: z.string().min(1, 'Pick a start date'),
  periodEnd: z.string().min(1, 'Pick an end date'),
  notes: z.string().trim().max(500).optional(),
});
export type CreatePayrollRunInput = z.infer<typeof CreatePayrollRunSchema>;

/** Add a payslip to a run (Figma Finance → "Add Payslip"). Mirrors `AddPayslipDto`. */
export const AddPayslipSchema = z.object({
  therapistId: z.string().uuid('Select a therapist'),
  grossPaise,
  sessionsCount: z.coerce.number().int().min(0).optional(),
  notes: z.string().trim().max(500).optional(),
});
export type AddPayslipInput = z.infer<typeof AddPayslipSchema>;
